function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ValueRangeConfig',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // v-model
    fromSelection: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // atributos seleccionados
    titleKey: {
      type: String,
      default: 'attribute_name'
    },
    idKey: {
      type: String,
      default: 'id'
    },
    intRule: {
      type: Function,
      required: true
    },
    gapRule: {
      type: Function,
      required: true
    }
  },
  data: function data() {
    return {
      sectionsLocal: this.clone(this.value),
      syncing: false,
      expanded: null
    };
  },
  computed: {
    fromKeys: function fromKeys() {
      var _this = this;
      var arr = Array.isArray(this.fromSelection) ? this.fromSelection : [];
      return arr.map(function (it) {
        return _this.itemKey(it);
      }).filter(Boolean).map(String).sort().join('|');
    },
    displayedSections: function displayedSections() {
      return (this.sectionsLocal || []).slice().reverse();
    }
  },
  watch: {
    // in -> local
    value: function value(nv) {
      var next = this.clone(nv);
      if (JSON.stringify(next) !== JSON.stringify(this.sectionsLocal)) {
        this.sectionsLocal = next;
      }
    },
    // local -> out (v-model)
    sectionsLocal: {
      deep: true,
      handler: function handler(v) {
        if (this.syncing) return;
        this.$emit('input', this.clone(v));
      }
    },
    // sync con selección
    fromKeys: {
      immediate: true,
      handler: function handler() {
        var _this2 = this;
        var arr = Array.isArray(this.fromSelection) ? this.fromSelection : [];
        var wantMap = {};
        for (var i = 0; i < arr.length; i++) {
          var it = arr[i];
          var id = this.itemKey(it);
          if (!id) continue;
          if (!wantMap[id]) wantMap[id] = this.newSectionFromItem(it);
        }
        this.syncing = true;
        try {
          // 1) eliminar no presentes
          var next = this.sectionsLocal.filter(function (s) {
            return !!wantMap[s.id];
          });

          // 2) añadir faltantes
          var currentIds = new Set(next.map(function (s) {
            return s.id;
          }));
          Object.keys(wantMap).forEach(function (id) {
            if (!currentIds.has(id)) next.push(wantMap[id]);
          });

          // 3) asegurar que la última fila sea siempre default:true
          next = next.map(function (sec) {
            return _this2.ensureDefaultAtEnd(sec);
          });
          if (JSON.stringify(next) !== JSON.stringify(this.sectionsLocal)) {
            this.sectionsLocal = next;
          }
          this.$nextTick(function () {
            _this2.expanded = _this2.sectionsLocal.length ? _this2.sectionsLocal.length - 1 : null;
          });
        } finally {
          this.$nextTick(function () {
            _this2.syncing = false;
          });
        }
      }
    }
  },
  methods: {
    rulesFor: function rulesFor(section, index) {
      var _this3 = this;
      // Filtra las filas "no default"
      var normals = (section.ranges || []).filter(function (r) {
        return r && r.default !== true;
      });
      var prevVal = index > 0 && normals[index - 1] ? normals[index - 1].value : undefined;

      // Adaptamos las rules del padre a la firma (v) => boolean|string de Vuetify
      return [function (v) {
        return _this3.intRule(v);
      }, function (v) {
        return _this3.gapRule(v, {
          index: index,
          prev: prevVal
        });
      }];
    },
    itemKey: function itemKey(item) {
      if (item && _typeof(item) === 'object' && item[this.idKey] != null && item[this.idKey] !== '') {
        return String(item[this.idKey]);
      }
      return null;
    },
    itemTitle: function itemTitle(item) {
      if (item && _typeof(item) === 'object' && item[this.titleKey] != null) {
        return String(item[this.titleKey]);
      }
      return 'nueva_configuracion';
    },
    clone: function clone(x) {
      return JSON.parse(JSON.stringify(x || []));
    },
    // Asegura que la última fila sea default:true y que las no-default tengan op por defecto
    ensureDefaultAtEnd: function ensureDefaultAtEnd(section) {
      var sec = this.clone(section);
      if (!Array.isArray(sec.ranges)) sec.ranges = [];
      var normals = sec.ranges.filter(function (r) {
        return r && r.default !== true && r.isNull !== true;
      }).map(function (r) {
        return {
          id: r.id || sec.id + '-' + Date.now(),
          op: r.op && String(r.op).trim() || '<=',
          value: r.value == null ? '' : String(r.value),
          output: r.output == null ? '' : String(r.output)
        };
      });
      var nullRows = sec.ranges.filter(function (r) {
        return r && r.isNull === true;
      }).map(function (r) {
        return {
          id: r.id || sec.id + '-' + Date.now(),
          isNull: true,
          output: r.output == null ? '' : String(r.output)
        };
      });
      var defaultRows = sec.ranges.filter(function (r) {
        return r && r.default === true;
      }).map(function (r) {
        return {
          id: r.id || sec.id + '-' + Date.now(),
          default: true,
          output: r.output == null ? '' : String(r.output)
        };
      });
      var nullRow = nullRows.length ? nullRows[nullRows.length - 1] : sec._nullRemoved ? null : {
        id: sec.id + '-' + Date.now(),
        isNull: true,
        output: ''
      };
      var defaultRow = defaultRows.length ? defaultRows[defaultRows.length - 1] : {
        id: sec.id + '-' + Date.now(),
        default: true,
        output: ''
      };

      // Orden: normales ... | null | default
      sec.ranges = [].concat(_toConsumableArray(normals), _toConsumableArray(nullRow ? [nullRow] : []), [defaultRow]);
      return sec;
    },
    // Nueva sección base: 2 rangos con op '<=' + 1 default
    newSectionFromItem: function newSectionFromItem(item) {
      var id = this.itemKey(item);
      var ts = function ts() {
        return Date.now() + '-' + Math.random().toString(36).slice(2, 7);
      };
      return {
        id: id,
        title: this.itemTitle(item),
        _nullRemoved: false,
        ranges: [{
          id: id + '-' + ts(),
          op: '<=',
          value: '',
          output: ''
        }, {
          id: id + '-' + ts(),
          op: '<=',
          value: '',
          output: ''
        }, {
          id: id + '-' + ts(),
          isNull: true,
          output: ''
        },
        // null antes de default
        {
          id: id + '-' + ts(),
          default: true,
          output: ''
        } // default al final
        ]
      };
    },
    addRange: function addRange(sectionId) {
      var idx = this.sectionsLocal.findIndex(function (s) {
        return s.id === sectionId;
      });
      if (idx === -1) return;
      var sec = this.clone(this.sectionsLocal[idx]);

      // insertar antes del default y null
      var insertAt = Math.max(0, sec.ranges.length - 2);
      sec.ranges.splice(insertAt, 0, {
        id: sectionId + '-' + Date.now(),
        op: '<=',
        value: '',
        output: ''
      });
      this.$set(this.sectionsLocal, idx, this.ensureDefaultAtEnd(sec));
    },
    removeRange: function removeRange(sectionId, index) {
      var secIdx = this.sectionsLocal.findIndex(function (s) {
        return s.id === sectionId;
      });
      if (secIdx === -1) return;
      var sec = this.clone(this.sectionsLocal[secIdx]);
      var row = sec.ranges[index];
      if (!row || row.default === true) return; // proteger especiales
      if (row.isNull === true) {
        sec._nullRemoved = true;
      }
      sec.ranges.splice(index, 1);
      this.$set(this.sectionsLocal, secIdx, this.ensureDefaultAtEnd(sec));
    },
    removeSection: function removeSection(sectionId) {
      this.sectionsLocal = this.sectionsLocal.filter(function (s) {
        return s.id !== sectionId;
      });
      this.$emit('remove-from-selection', sectionId);
    }
  }
};